import {projectKeys} from 'fenceTypesConstants';
import {projectKeysHuman} from 'App';
import {calculateMissingSpace} from 'Project/Bottom/SupplementSpace';
import React from 'react';

import styled from 'styled-components';
import {useFormikContext} from 'formik';
import {useDispatch, useSelector} from 'react-redux';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const projects = [
  'span',
  'gateway',
  'gate',
];

export const GuessLastIssue = (values, errors, t) => {
  const atLeastOneFinished = values.span.chosen || values.gateway.chosen || values.gate.chosen;
  if (!atLeastOneFinished) return t('finishOne');
  const hingesIssue = (values.gateway.chosen && errors.gateway?.hinges) ||
    (values.gate.chosen && (values.gate.gateType === 'gateTilting' || values.gate.gateType === 'singleLeafGate' || values.gate.gateType === 'foldingGate' || values.gate.gateType === 'singleLeafFoldingGate' || values.gate.gateType === 'nonSymmetricalGate') && errors.gate?.hinges);
  if (hingesIssue) return t('finishHinges');
  const issueInProject = projects.some(p => {
    return values[p].chosen && errors[p] && Object.keys(errors[p]).length;
  })
  const issueWithAutomation = (localStorage.getItem('automationErr') !== '' && localStorage.getItem('automationErr') !== null);
  if (issueInProject || issueWithAutomation) return t('finishErrors');
  const missingSpaceKey = projectKeys.find((key) => {
    if (!values[key].chosen) return false;
    const ms = calculateMissingSpace({
      space: values[key].space,
      supplementSpace: values[key].supplementSpace,
    });
    return ms ? key : false;
  })
  if (missingSpaceKey) return `${t("finishFix")} ${projectKeysHuman[missingSpaceKey]}.`;
  return '';
}

const FinishForm = () => {
  const formik = useFormikContext();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const finishingProject = useSelector((state) => state.app.finishingProject);
  const error = useSelector((state) => state.app.error);
  const message = useSelector((state) => state.app.message);
  if (!finishingProject) return null;
  const lastIssue = GuessLastIssue(formik.values, formik.errors, t);

  return (
    <Modal className="modal" tabIndex="-1" role="dialog">
      <div className="modal-dialog" role="document">
        <Inner className="modal-content">
          <HeaderContainer>
            <Header>{t("oneMoreStep")}</Header>
            <Close
              type="button"
              data-sentry="closeFinishForm"
              className="btn"
              onClick={() => dispatch({type: 'EXIT_FINISH_PROJECT'})}>
              <FontAwesomeIcon icon={faTimes}/>
            </Close>
          </HeaderContainer>
          <div>
            <SubHeader>{t('finishHeader')}</SubHeader>
            <div>
              <Row>
                <div>
                  <input
                    type="email"
                    className="form-control"
                    placeholder={t('emailAddress')}
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required
                  />
                  <span>{formik.touched?.email && formik.errors?.email}</span>
                </div>
                <div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t('projectName')}
                    name="projectName"
                    value={formik.values.projectName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <span>{formik.touched?.projectName && formik.errors?.projectName}</span>
                </div>
                <Send className="btn" type="button" disabled={lastIssue} onClick={formik.handleSubmit}
                      data-sentry="send"
                >
                  {t('sendProject')}
                </Send>
              </Row>
              <ResponseContainer error={error}>
                <span>{message}</span>
                {formik.isSubmitting && <span>{t("sending")}</span>}
                {lastIssue && <span>{lastIssue}</span>}
              </ResponseContainer>
            </div>
          </div>
        </Inner>
      </div>
    </Modal>
  );
};

const Modal = styled.div`
  display: block;
  background-color: rgba(0, 0, 0, 0.9);

  .modal-dialog {
    max-width: 850px;
  }
`;

const Inner = styled.div`
  padding: 3rem;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

const Header = styled.h1`
  font-weight: 400;
`;

const Close = styled.button`
  font-size: 1.5rem;
  padding: 0;
`;

const SubHeader = styled.div`
  font-size: 2rem;
  font-weight: 300;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 2rem;

  input {
    border-radius: 22px;
    background: #e6e6e6;
    color: #000;
    width: 228px;
  }

  input::-webkit-input-placeholder {
    color: #000;
  }

  span {
    color: #ff0000;
    display: inline-block;
    margin-top: .5rem;
  }
`;

const Send = styled.button`
  background: #44AF69;
  padding: .4rem 0;
  color: #ffff;
  width: 228px;

  &:hover {
    color: #ffff;
  }
`;

const ResponseContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${props => props.error ? '#ff0000' : 'inherit'};
`;

export default FinishForm;
